import { render, staticRenderFns } from "./product-category-value.vue?vue&type=template&id=4fdfb1f4&scoped=true&"
import script from "./product-category-value.vue?vue&type=script&lang=js&"
export * from "./product-category-value.vue?vue&type=script&lang=js&"
import style0 from "./product-category-value.vue?vue&type=style&index=0&id=4fdfb1f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfb1f4",
  null
  
)

export default component.exports